export default {"src":"/europe/spain/_next/static/media/pag-next.349c03e2.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};